import { authedFetch } from '@/lib/authed-fetch';
import type { EventPayment, EventRegistration } from '@/lib/event-registration';

export type AdminEventPaymentRow = Readonly<{
  registration: EventRegistration;
  latestPayment: EventPayment | null;
  receiptUrl: string | null;
  member: {
    email: string | null;
    fullName: string | null;
    id: string;
  };
}>;

async function parseApiResponse<T>(response: Response, fallbackMessage: string): Promise<T> {
  const payload = (await response.json().catch(() => null)) as ({ error?: string } & T) | null;

  if (!response.ok) {
    throw new Error(payload?.error ?? fallbackMessage);
  }

  return payload as T;
}

export async function fetchAdminEventPayments(
  tenantSlug: string,
  eventId: string
): Promise<AdminEventPaymentRow[]> {
  const response = await authedFetch(
    `/api/admin/${encodeURIComponent(tenantSlug)}/events/${encodeURIComponent(eventId)}/payments`
  );
  return parseApiResponse<AdminEventPaymentRow[]>(response, 'Could not load event payments.');
}

export async function reviewAdminEventPayment(
  tenantSlug: string,
  eventId: string,
  paymentId: string,
  decision: 'approve' | 'reject'
): Promise<AdminEventPaymentRow[]> {
  const response = await authedFetch(
    `/api/admin/${encodeURIComponent(tenantSlug)}/events/${encodeURIComponent(
      eventId
    )}/payments/${encodeURIComponent(paymentId)}`,
    {
      body: JSON.stringify({ decision }),
      headers: { 'Content-Type': 'application/json' },
      method: 'PATCH',
    }
  );
  return parseApiResponse<AdminEventPaymentRow[]>(response, 'Could not review payment.');
}
